import { useEffect } from "react"
import i18n from "@/i18n"

export default function LangHtmlSync() {
  useEffect(() => {
    const syncLang = () => {
      document.documentElement.lang = i18n.language?.split("-")[0] || "ru"
    }
    syncLang()
    i18n.on("languageChanged", syncLang)
    return () => {
      i18n.off("languageChanged", syncLang)
    }
  }, [])
  return null
}
